(function() {

    /* The product form */
    var productForm = '#js-product-form';
    var $productForm = $(productForm);

    /* The radio inputs */
    var productColor = '.js-product-color';
    var $productColor = $(productColor);
    var productSize = '.js-product-size';
    var $productSize = $(productSize);
    var productLanguage = '.js-product-language';
    var $productLanguage = $(productLanguage);
    var hasLanguages = $productLanguage.length > 1;

    /* The default select listing all the combinations */
    var combinations = '.js-product-variant-combinations';
    var $combinations = $(combinations);

    /* The image slider */
    var productVariantsSliders = '.js-product-variants-slider';
    var $productVariantsSliders = $(productVariantsSliders);

    /* The "add to cart" button */
    var addToCartBtn = '#js-add-to-cart';
    var $addToCartBtn = $(addToCartBtn);

    /* The product size legend */
    var productSizeLegend = '#js-product-size-legend';
    var $productSizeLegend = $(productSizeLegend);

    var params = {
        disabledBtnClass: 'c-button--disabled',
        disabledLegendClass: 'is-disabled'
    };

    //	======================================================================  //
    //	Functions
    //	======================================================================  //

    /**
     * @function `getSizesForChosenColor`
     *
     * Return available sizes for chosen color.
     *
     * @param chosenColor (str) - the color string matching the data attribute
     * used in the default `select`.
     *
     * @return $sizes (node) - `option`s matching the chosen color, only if
     * available for purchase (not disabled)
     */
    function getSizesForChosenColor( chosenColor ) {
        var $sizes = $combinations.find('[data-color="'+chosenColor+'"]:enabled');
        return $sizes;
    }

    /**
     * @function `disableAllSizes`
     *
     * Disable all size `radio`s.
     */
    function disableAllSizes() {
        $productSize.attr('disabled', true);
    }

    /**
     * @function `enableThatSize`
     *
     * Find the `radio` button for a given size and enable it.
     */
    function enableThatSize( size ) {
        $(productSize+'[value="'+size+'"]').removeAttr('disabled');
    }

    /**
     * @function `disableSizeLegend`
     */
    function disableSizeLegend() {
        $productSizeLegend.addClass(params.disabledLegendClass);
    }

    /**
     * @function `enableSizeLegend`
     */
    function enableSizeLegend() {
        $productSizeLegend.removeClass(params.disabledLegendClass);
    }

    /**
     * @function `showAvailableSizes`
     *
     * Retrieve available (in stock) sizes for the selected product color.
     *
     * @param $chosenColor (node) - the chosen color (radio button)
     *
     * 1. Uncheck `radio` button if size unavailable.
     */
    function showAvailableSizes( $chosenColor ) {
        var color = $chosenColor.val();
        var $availableSizeOptions = getSizesForChosenColor( color );
        var availableSizeOptionsLength = $availableSizeOptions.length;
        disableAllSizes();
        for(var i = 0; i < availableSizeOptionsLength; i++) {
            var size = $availableSizeOptions.eq(i).data('size');
            enableThatSize( size );
        }
        $(productSize+'[disabled]').prop('checked', false); /* [1] */
    }

    /**
     * @function `showRelatedPicture`
     *
     * Slide to the related picture when a color is chosen.
     *
     * @param $chosenColor
     *
     * 1. Quick escape if no slider
     * 2. Quick escape if no related picture
     */
    function showRelatedPicture( $chosenColor ) {
        if( !$productVariantsSliders.length ) { /* [1] */
            return;
        }
        var color = $chosenColor.val();
        var $firstRelatedSlide = $productVariantsSliders.find('[data-color="'+
            color+'"]').eq(0);
        if( !$firstRelatedSlide.length ) { /* [2] */
            return;
        }
        var firstRelatedSlideIndex = $firstRelatedSlide.data('slick-index');
        $productVariantsSliders.slick('slickGoTo', firstRelatedSlideIndex);
    }

    /**
     * @function `disableAddToCartButton`
     *
     * Disable the "add to cart" button using the browser's default `disabled`
     * feature, styling the button and changing its label.
     *
     * 1. If there's no color option, there's at least a size option (otherwise)
     *    the "add to cart" button would not have been disabled.
     * 2. Both color and size options must be set (combination)
     */
    function disableAddToCartButton() {
        var disabledLabel = '';
        disabledLabel = $addToCartBtn.data('size-label');

        // If this is a book page
        if (hasLanguages) {
            disabledLabel = $addToCartBtn.data('language-label');
        }

        $addToCartBtn
            .attr('disabled', true)
            .addClass(params.disabledBtnClass)
            .text(disabledLabel);
    }

    /**
     * @function `enableAddToCartButton`
     *
     * Enable the "add to cart" button remove the browser's default `disabled`
     * feature, styling the button and changing its label.
     */
    function enableAddToCartButton() {
        var enabledLabel = $addToCartBtn.data('enabled-label');
        $addToCartBtn
            .removeAttr('disabled')
            .removeClass(params.disabledBtnClass)
            .text(enabledLabel);
    }

    /**
     * @function `getMatchingCombination`
     *
     * Find the `option` matching the choice (color/size) of the user.
     *
     * @return `$possibleOptions` (node) - a collection of `option elements`
     */
    function getMatchingCombination() {
        $possibleOptions = $combinations.find('option:not([disabled])');
        var color, size, language;
        if( $productColor.length ) {
            color = $(productColor+':checked').val();
            $possibleOptions = $possibleOptions.filter('[data-color="'+color+'"]');
        }
        if( $productSize.length ) {
            size = $(productSize+':checked').val();
            $possibleOptions = $possibleOptions.filter('[data-size="'+size+'"]');
        }
        if( $productLanguage.length ) {
            language = $(productLanguage+':checked').val();
            $possibleOptions = $possibleOptions.filter('[data-language="'+language+'"]');
        }
        // console.log('Combination found with color:', color, ' and size:', size);
        return $possibleOptions;
    }

    /**
     * @function `productFormValidation`
     *
     * Select the single matching option, or prevent form submission.
     *
     * 1. Make sure there is more than one option selectable (if just one,
     *    it is preselected).
     *
     * @param submitEvent (event) - the submit event
     */
    function productFormValidation( submitEvent ) {
        if ($combinations && $combinations.find('option').length > 1) { /* [1] */
            var $option = getMatchingCombination();
            if( $option.length !== 1 ) {
                submitEvent.preventDefault();
            }
            $option.prop('selected', true);
        }
        return;
    }

    //	======================================================================  //
    //	On ready
    //	======================================================================  //

    /**
     * 1. Quick escape if no "add to cart" button.
     * 2. Quick escape if no product sizes / language or just one.
     * 3. Passing those two cases means that the user has to make a choice.
     * 4. Quick escape if no product sizes: we don't have to disable the sizes.
     * 5. Quick escape if no product colors: we don't have to disable the colors.
     * 6. Quick escape if no product languages: we don't have to disable the languages.
     */
    _$document.ready(function() {
        if( !$addToCartBtn.length ) { /* [1] */
            return;
        }
        if( $productColor.length + $productSize.length + $productLanguage.length === 0 ) {
            return;
        }
        if( $productColor.length && $productSize.length + $productLanguage.length < 2 ) { /* [2] */
            return;
        }
        disableAddToCartButton(); /* [3] */
        if( !$productSize.length ) { /* [4] */
            return;
        }
        if( !$productColor.length ) { /* [5] */
            return;
        }
        if( !$productLanguage.length ) { /* [6] */
            return;
        }
        if( !$productColor.val() ) {
            disableAllSizes();
            disableSizeLegend();
        }
    });

    //	======================================================================  //
    //	On change
    //	======================================================================  //

    /**
     * 0. Listen to both `change` (default) and `click` so that if the user
     *    selected the blue shirt, then kept sliding the images to "see other
     *    options" and stops sliding when the current slide shows a red shirt,
     *    he will want to make sure that he will order the blue one. He might
     *    thus click again on the "blue shirt" `radio` button (even if the UI
     *    shows it's selected) and expect that the slider would animate to show
     *    the blue shirt. That last click would not trigger the `change` event.
     *
     * 1. Enable the "add to cart" button if there's no color option and the
     *    user has chosen a size.
     * 2. If a color has been chosen...
     * 3. - No product size to choose from: enable the button
     * 4. - A size is chosen:
     * 5. -- Make sure it's available for that color.
     * 6. - A size is not chosen: disable the button.
     */
    var changeSelectors = [productColor, productSize, productLanguage].join(',');
    _$document.on('change, click', changeSelectors, function(e) { /* [0] */
        if( $(e.target).closest(productColor).length ) {
            enableSizeLegend();
            showAvailableSizes( $(this) );
            showRelatedPicture( $(this) );
        }
        var colorChosen = $(productColor+':checked').val();
        var $sizeChosen = $(productSize+':checked');
        var sizeChosen = $sizeChosen.val();
        var $languageChosen = $(productLanguage+':checked');
        var languageChosen = $languageChosen.val();
        if( !$productColor.length && sizeChosen ) { /* [1] */
            enableAddToCartButton();
        }
        else if( !$productColor.length && languageChosen ) { /* [1] */
            enableAddToCartButton();
        }
        else if( colorChosen ) { /* [2] */
            if ( !$productSize.length ) { /* [3] */
                enableAddToCartButton();
            }
            else if( sizeChosen ) { /* [4] */
                if( !$sizeChosen.prop('disabled') ) { /* [5] */
                    enableAddToCartButton();
                }
                else {
                    disableAddToCartButton();
                }
            }
            else { /* [6] */
                disableAddToCartButton();
            }
        }
        else {
            disableAddToCartButton();
        }
    });

    //	======================================================================  //
    //	Add to cart
    //	======================================================================  //

    _$document.on('submit', productForm, function(e) {
        productFormValidation(e);
    });

})();
